import styled from '@emotion/styled';
import type { ButtonProps, PopoverOrigin } from '@mui/material';
import { Button } from '@mui/material';
import Menu from '@mui/material/Menu';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useMenu } from '../../../../../../hooks/use-menu';

const StyledMenu = styled(Menu)`
  margin-top: 8px;
  .MuiPaper-root {
    padding: 0;
    box-shadow: 0px 8px 16px 0px #0C124514;
    border: 1px solid #F0F4F6;
  }
`;

type AddItemMenuButtonProps = {
  cta: React.ReactNode;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
} & ButtonProps;

export const AddItemMenuButton: React.FC<AddItemMenuButtonProps> = ({ children, className, cta, anchorOrigin, transformOrigin, ...props }) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        className={twMerge('rounded-lg text-sm font-normal', className)}
        onClick={handleMenuOpen}
        disableElevation
        {...props}
      >
        {cta}
      </Button>

      <StyledMenu
        anchorOrigin={anchorOrigin ?? {
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={transformOrigin ?? {
          vertical: 'top',
          horizontal: 'center',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
      >
        {children}
      </StyledMenu>
    </>
  );
};